export enum WORKING_SCHEDULE_TYPE {
  HOLIDAY = 4,
  COMPENSATION_DAY = 5
}
